<template>
  <div
    class="app-main-content"
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <div class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="920"
          @click-more="value=>{isAdvancedQuery=value}"
          @simSearchItemCallBack="toAdvancedQuery()"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations" style="display: flex;">
            <span style="color: #666666;">ETD</span>
            <el-select
              v-model="timeRange"
              no="1"
              filterable
              style="width: 100px;margin-left: 5px;"
              @change="onTimeRangeChange"
            >
              <el-option
                v-for="(item,index) in TIME_RANGES"
                :key="index"
                :label="isZh?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
            <el-date-picker
              v-model="commonFilter.start"
              no="2"
              :disabled="timeRange!==CUSTOM.code"
              type="date"
              value-format="yyyy-MM-dd"
              :editable="false"
              :clearable="false"
              style="width: 120px;margin:0 5px;"
            />-
            <el-date-picker
              v-model="commonFilter.end"
              no="3"
              :disabled="timeRange!==CUSTOM.code"
              type="date"
              value-format="yyyy-MM-dd"
              :editable="false"
              :clearable="false"
              style="width: 120px;margin-left: 5px;"
            />
            <cargo-advance-select
              no="4"
              :select-type="TYPE_NAMES.basic_data_Region"
              filterable
              :multiple="true"
              :default-multiple-value="commonFilter.regions"
              :tag-name="isZh?'name':'nameEnglish'"
              :placeholder="'-'+$t('CargoMsg.Cargo_Airline')+'-'"
              style="width: 150px;margin: 0 5px;"
              @parentCallBack="p=>{commonFilter.regions=p.value}"
            />
            <el-button
              v-show="$checkPermission(['button_AERouteCentral_Booking'])"
              no="5"
              :disabled="!(validFlight && bookingEnable && selectedRow.settleState === 0)"
              type="primary"
              @click="bookingHandler"
            >{{ $t('CargoMsg.Cargo_Booking') }}</el-button>
            <el-button
              v-show="$checkPermission(['button_AERouteCentral_ExportLoading'])"
              no="6"
              :disabled="!(selectedRow && (validFlight || selectedRow.departureTime === 'Co-Loader' || exportTemplateEnabled))"
              type="primary"
              @click="exportTemplateHandler('FLIGHTLOADINGPLAN')"
            >{{ $t('queryJob.exportLoadingPlan') }}</el-button>
            <el-button
              v-show="$checkPermission(['button_AERouteCentral_ExportSaleReport'])"
              no="7"
              :disabled="!(selectedRow && (validFlight || selectedRow.departureTime === 'Co-Loader' || exportTemplateEnabled))"
              type="success"
              @click="exportTemplateHandler('AESALESREPORT')"
            >{{ $t('CargoMsg.Cargo_Print') }}</el-button>
            <el-menu
              no="8"
              text-color="#404144"
              active-text-color="#404144"
              mode="horizontal"
              class="el-menu-button el-button el-button--primary el-button--mini"
              :style="{width: $selectByLang('110px', '110px', '110px', '200px', '200px', '200px'), padding: '0' }"
              @select="menuBarItemClickHandler"
            >
              <el-submenu index="moreOperator">
                <span slot="title" class="el-menu-btn-text">{{ $t('queryJob.moreOperations') }}</span>
                <el-submenu index="template">
                  <template slot="title">{{ $t('queryJob.routeOperation') }}</template>
                  <el-menu-item
                    v-permission="['button_AERouteCentral_BookingDone']"
                    :disabled="!btBookingDoneEnabled"
                    index="btBookingDone"
                  >{{ $t('queryJob.completeBooking') }}</el-menu-item>
                  <el-menu-item
                    v-permission="['button_AERouteCentral_WarehouseEntry']"
                    :disabled="!btBookingInEnabled"
                    index="btBookingIn"
                  >{{ $t('queryJob.warehousing') }}</el-menu-item>
                  <el-menu-item
                    v-permission="['button_AERouteCentral_LoadingBoard']"
                    :disabled="!btLoadingEnabled"
                    index="btLoading"
                  >{{ $t('queryJob.mountingBoard') }}</el-menu-item>
                  <el-menu-item
                    v-permission="['button_AERouteCentral_PullIn']"
                    :disabled="!btPullInEnabled"
                    index="btPullIn"
                  >{{ $t('queryJob.pullGood') }}</el-menu-item>
                  <el-menu-item
                    v-permission="['button_AERouteCentral_AdjustFlight']"
                    :disabled="!btAdjustFlightEnabled"
                    index="btAdjustFlight"
                  >{{ $t('queryJob.applicationForFlightAdjustment') }}</el-menu-item>
                  <el-menu-item
                    :disabled="!btMixFlightEnabled"
                    index="btMixFlight"
                  >{{ $t('queryJob.allocateFlights') }}</el-menu-item>
                  <el-menu-item
                    :disabled="!btCheckBookingEnabled"
                    index="btCheckBooking"
                  >{{ $t('queryJob.confirmCabinAllocation') }}</el-menu-item>
                  <el-menu-item
                    :disabled="!btCancelCheckBookingEnabled"
                    index="btCancelCheckBooking"
                  >{{ $t('queryJob.cancelConfirmationOfCabinAllocation') }}</el-menu-item>
                  <el-menu-item
                    v-permission="['button_AERouteCentral_CopyWarehouseInfo']"
                    :disabled="!btCopyWarehouseInfoEnabled"
                    index="btCopyWarehouseInfo"
                  >{{ $t('queryJob.copyIncomingData') }}</el-menu-item>
                  <el-menu-item
                    v-permission="['button_AERouteCentral_OperatorRemarks']"
                    :disabled="!btOperatorRemarksEnabled"
                    index="btOperatorRemarks"
                  >{{ $t('SeaExport.AdditionalNotes') }}</el-menu-item>
                  <el-menu-item
                    v-permission="['button_AERouteCentral_OtherWarehouseNotes']"
                    :disabled="!btOtherWarehouseNotesEnabled"
                    index="btOtherWarehouseNotes"
                  >{{ $t('queryJob.otherRemarks') }}</el-menu-item>
                </el-submenu>
                <el-submenu v-show="moreOperatorVisible.operatorVisible" index="operator">
                  <template slot="title">{{ $t('SeaExport.FieldOperation') }}</template>
                  <el-menu-item
                    v-show="moreOperatorVisible.operator.btDeclareCustoms"
                    :disabled="!btDeclareCustomsEnabled"
                    index="btDeclareCustoms"
                  >{{ $t('CargoMsg.Cargo_CustomsDeclaration') }}</el-menu-item>
                  <el-menu-item
                    v-show="moreOperatorVisible.operator.btSiteRemark"
                    :disabled="!btSiteRemarkEnabled"
                    index="btSiteRemark"
                  >{{ $t('SeaExport.OperatingInstructions') }}</el-menu-item>
                  <el-menu-item
                    v-show="moreOperatorVisible.operator.btOtherCharges"
                    :disabled="!btOtherChargesEnabled"
                    index="btOtherCharges"
                  >{{ $t('queryJob.otherExpenses') }}</el-menu-item>
                  <el-menu-item
                    v-show="moreOperatorVisible.operator.btDelivery"
                    :disabled="!btDeliveryEnabled"
                    index="btDelivery"
                  >{{ $t('queryJob.delivery') }}</el-menu-item>
                  <el-menu-item
                    v-show="moreOperatorVisible.operator.btDeliveryAgent"
                    :disabled="!btDeliveryAgentEnabled"
                    index="btDeliveryAgent"
                  >{{ $t('queryJob.deliveryAgent') }}</el-menu-item>
                  <el-menu-item
                    v-show="moreOperatorVisible.operator.btUploadLoadingPic"
                    :disabled="!btUploadLoadingPicEnabled"
                    index="btUploadLoadingPic"
                  >{{ $t('queryJob.uploadBoardPhotos') }}</el-menu-item>
                  <el-menu-item
                    v-show="moreOperatorVisible.operator.btLabel"
                    :disabled="curDataType!==6"
                    index="btLabel"
                  >{{ $t('queryJob.subLabel') }}</el-menu-item>
                </el-submenu>
                <el-menu-item
                  v-show="!moreOperatorVisible.operatorVisible"
                  index="operator"
                >{{ $t('SeaExport.FieldOperation') }}</el-menu-item>
                <el-submenu v-show="moreOperatorVisible.billVisible" index="bill">
                  <template slot="title">{{ $t('SeaExport.Documentation') }}</template>
                  <el-menu-item
                    v-show="moreOperatorVisible.bill.btBillingMAWB"
                    :disabled="!btBillingMAWBEnabled"
                    index="btBillingMAWB"
                  >{{ $t('queryJob.prefabricatedMasterOrder') }}</el-menu-item>
                  <el-menu-item
                    v-show="moreOperatorVisible.bill.btBillingHAWB"
                    :disabled="!btBillingHAWBEnabled"
                    index="btBillingHAWB"
                  >{{ $t('queryJob.prefabricationOrderSplitting') }}</el-menu-item>
                  <el-menu-item
                    v-show="moreOperatorVisible.bill.btPrintMAWB"
                    :disabled="!btPrintMAWBEnabled"
                    index="btPrintMAWB"
                  >{{ $t('queryJob.printMasterOrder') }}</el-menu-item>
                  <el-menu-item
                    v-show="moreOperatorVisible.bill.btPrintHAWB"
                    :disabled="!btPrintHAWBEnabled"
                    index="btPrintHAWB"
                  >{{ $t('queryJob.printSplit') }}</el-menu-item>
                </el-submenu>
                <el-menu-item
                  v-show="!moreOperatorVisible.billVisible"
                  index="bill"
                >{{ $t('SeaExport.Documentation') }}</el-menu-item>
                <el-submenu v-show="moreOperatorVisible.trackVisible" index="track">
                  <template slot="title">{{ $t('queryJob.track') }}</template>
                  <el-menu-item
                    v-show="moreOperatorVisible.track.btTakeOff"
                    :disabled="!btTakeOffEnabled"
                    index="btTakeOff"
                  >{{ $t('queryJob.takeOff') }}</el-menu-item>
                  <el-menu-item
                    v-show="moreOperatorVisible.track.btArrival"
                    :disabled="!btArrivalEnabled"
                    index="btArrival"
                  >{{ $t('queryJob.arrival') }}</el-menu-item>
                  <el-menu-item
                    v-show="moreOperatorVisible.track.btFlightState"
                    :disabled="!btFlightStateEnabled"
                    index="btFlightState"
                  >{{ btFlightStateLabel }}</el-menu-item>
                </el-submenu>
                <el-menu-item
                  v-show="!moreOperatorVisible.trackVisible"
                  index="track"
                >{{ $t('queryJob.track') }}</el-menu-item>
              </el-submenu>
            </el-menu>
            <el-button no="9" type="primary" @click="queryJobMbl">{{ $t('queryJob.billOfLadingInquiry') }}</el-button>
            <el-button no="10" type="primary" @click="gridApi.expandAll()">{{ $t('queryJob.expandAll') }}</el-button>
            <el-button no="11" type="primary" @click="onCollapseFlights">{{ $t('queryJob.putItAllAway') }}</el-button>
            <el-checkbox
              v-model="autoRefresh"
              no="12"
              style="margin: 0 5px 0 15px;"
              @change="resetTimer"
            >{{ $t('SeaExport.AutomaticallyRefresh') }}</el-checkbox>
            <el-checkbox
              v-model="showAll"
              no="13"
              style="margin: 0 5px;"
            >{{ $t('queryJob.noBusinessFlight') }}</el-checkbox>
          </div>
        </search-item>
        <div class="section grid-wrapper" style="min-height: 350px;">
          <cargo-ag-grid
            no="grid"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :check-main-record="false"
            :deselect-main-record="false"
            :deselect-sub-record="true"
            :auto-fit-content="false"
            :shift-select="true"
            :ctrl-select="true"
            style="width: 100%;"
            @gridReady="params=>{gridApi=params.api}"
            @shiftSelects="onShiftOrCtrlSelects"
            @ctrlSelects="onShiftOrCtrlSelects"
            @rowGroupOpened="onRowSpanMethod"
            @expandOrCollapseAll="onRowSpanMethod"
          />
          <div
            v-if="keyboardSelectStatistics.visible"
            style="position: fixed;margin-left: 50%;padding: 5px 5px 5px 30px;border: 1px solid #bdc3c7;background: #FFFFCC;"
          >
            <b>{{ keyboardSelectStatistics.quantityContract }}</b>
            <b style="margin-left: 20px">{{ keyboardSelectStatistics.weightContract.toFixed(1) }}</b>
            <b style="margin-left: 20px">{{ keyboardSelectStatistics.cubageContract.toFixed(3) }}</b>
            <b style="margin-left: 40px">{{ keyboardSelectStatistics.quantityActual }}</b>
            <b style="margin-left: 20px">{{ keyboardSelectStatistics.weightActual.toFixed(1) }}</b>
            <b style="margin-left: 20px">{{ keyboardSelectStatistics.cubageActual.toFixed(3) }}</b>
          </div>
        </div>
        <div>
          <div style="display: flex;float: right;">
            <b>{{ $t('SeaExport.Actual') }}</b>
            <div style="padding: 0 10px;">{{ $t('SeaExport.Piece') }}</div>
            <b>{{ quantityActual }}</b>
            <div style="padding: 0 10px;">{{ $t('queryJob.heavy') }}</div>
            <b>{{ weightActual.toFixed(1) }}</b>
            <div style="padding: 0 10px;">{{ $t('SeaExport.Volume') }}</div>
            <b>{{ cubageActual.toFixed(3) }}</b>
            <div
              style="padding-left: 10px;font-weight: bold;"
            >{{ $t('CargoMsg.Cargo_Consignation') }}</div>
            <div style="padding: 0 10px;">{{ $t('SeaExport.Piece') }}</div>
            <b>{{ quantityContract }}</b>
            <div style="padding: 0 10px;">{{ $t('queryJob.heavy') }}</div>
            <b>{{ weightContract.toFixed(1) }}</b>
            <div style="padding: 0 10px;">{{ $t('SeaExport.Volume') }}</div>
            <b>{{ cubageContract.toFixed(3) }}</b>
          </div>
        </div>
      </div>
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 订舱对话框 -->
    <booking-dialog
      :visible.sync="bookingDialog.visible"
      :flight="bookingDialog.flight"
      :jobs="bookingDialog.jobs"
    />
    <!-- 提单查询对话框 -->
    <query-mbl-dialog :visible.sync="queryMblDialog.visible" @callback="queryMblCallback" />
    <!-- 申请调配对话框 -->
    <mix-flight-dialog
      :visible.sync="mixFlightDialog.visible"
      :jobs="mixFlightDialog.jobs"
      @callback="toAdvancedQuery()"
    />
    <!-- 装板说明对话框 -->
    <loading-note-dialog
      :visible.sync="loadingNoteDialog.visible"
      :jobs="loadingNoteDialog.jobs"
      @callback="onRowSpanMethod({api: gridApi})"
    />
    <!-- 收货(外仓)对话框 -->
    <warehouse-entry-dialog
      :visible.sync="warehouseEntryDialog.visible"
      :job="warehouseEntryDialog.job"
      @callback="toAdvancedQuery()"
    />
    <!-- 完成订舱对话框 -->
    <booking-done-dialog
      :visible.sync="bookingDoneDialog.visible"
      :flight="bookingDoneDialog.flight"
    />
    <!-- 报关对话框 -->
    <declare-customs-dialog
      :visible.sync="declareCustomsDialog.visible"
      :job="declareCustomsDialog.job"
    />
    <!-- 操作说明对话框 -->
    <operator-remark-dialog
      :visible.sync="operatorRemarkDialog.visible"
      :operator-id="operatorRemarkDialog.operatorId"
      :job="operatorRemarkDialog.job"
      @callback="gridApi.setRowData(rowData)"
    />
    <!-- 更新航班对话框 -->
    <update-flight-dialog
      :visible.sync="updateFlightDialog.visible"
      :operation="updateFlightDialog.operation"
      :flight="updateFlightDialog.flight"
      @callback="gridApi.setRowData(rowData)"
    />
    <!-- 交货代理对话框 -->
    <deliver-agent-dialog
      :visible.sync="deliverAgentDialog.visible"
      :jobs="deliverAgentDialog.jobs"
      @callback="gridApi.refreshCells({force:true})"
    />
    <!-- 上传打板照片对话框 -->
    <upload-loading-pic-dialog
      :visible.sync="uploadLoadingPicDialog.visible"
      :job="uploadLoadingPicDialog.job"
    />
    <!-- 分标签对话框 -->
    <warehouse-label-dialog
      :visible.sync="warehouseLabelDialog.visible"
      :job="warehouseLabelDialog.job"
      :warehouse-in="warehouseLabelDialog.warehouseIn"
      @callback="onWarehouseLabelChange"
    />
    <!-- 预制主单/分单对话框 -->
    <billingDialog
      no="billingDialog"
      :visible.sync="billingDialog.visible"
      :job="billingDialog.job"
      :doc-type="billingDialog.docType"
      @callback="delayUpdateButtonState"
    />
  </div>
</template>

<script>
import aeRouteCentralJS from './aeRouteCentral.js'
import moment from 'moment'
import jobDetailIcon from '@/assets/job-detail.png'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import bookingDialog from './components/routeCentral/aeBookingDialog'
import queryMblDialog from './components/routeCentral/queryMblDialog'
import mixFlightDialog from './components/routeCentral/mixFlightDialog'
import loadingNoteDialog from './components/routeCentral/loadingNoteDialog'
import warehouseEntryDialog from './components/routeCentral/warehouseEntryDialog'
import bookingDoneDialog from './components/routeCentral/bookingDoneDialog'
import declareCustomsDialog from './components/routeCentral/declareCustomsDialog'
import operatorRemarkDialog from './components/routeCentral/operatorRemarkDialog'
import updateFlightDialog from './components/routeCentral/updateFlightDialog'
import deliverAgentDialog from './components/routeCentral/deliverAgentDialog'
import uploadLoadingPicDialog from './components/routeCentral/uploadLoadingPicDialog'
import warehouseLabelDialog from './components/routeCentral/warehouseLabelDialog'
import billingDialog from './components/routeCentral/billingDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage } from '@/utils/commonUtil'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { TIME_RANGES, TODAY, CUSTOM } from '@/class/cargo/model/parameters/RouteConstants'
import { getAirExportJobListByKeys } from '@/api/AirExport/airExportJob'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts, { OPERATOR_EQUAL } from '@/class/cargo/model/parameters/OperatorConstants'

export default {
  name: 'AeRouteCentral',
  components: {
    searchItem, cargoAdvanceSelect, cargoTemplateSelectorDialog, bookingDialog, queryMblDialog, mixFlightDialog, loadingNoteDialog,
    warehouseEntryDialog, bookingDoneDialog, declareCustomsDialog, operatorRemarkDialog, updateFlightDialog, deliverAgentDialog,
    uploadLoadingPicDialog, warehouseLabelDialog, billingDialog
  },
  data() {
    const autoRefresh = LocalStorageUtils.getConfiguration('ROUTE_CENTRAL_AUTO_REFRESH') || false
    /* 更多操作按钮显示状态 */
    const moreOperatorVisible = {
      operator: {
        btDeclareCustoms: this.$checkPermission(['button_AERouteCentral_DeclareCustoms']),
        btSiteRemark: this.$checkPermission(['button_AERouteCentral_btSiteRemark']),
        btOtherCharges: this.$checkPermission(['button_AERouteCentral_btOtherCharges']),
        btDelivery: this.$checkPermission(['button_AERouteCentral_Delivery']),
        btDeliveryAgent: this.$checkPermission(['button_AERouteCentral_DeliveryAgent']),
        btUploadLoadingPic: this.$checkPermission(['button_AERouteCentral_UploadLoadingPic']),
        btLabel: this.$checkPermission(['button_AERouteCentral_Label'])
      },
      operatorVisible: false,
      bill: {
        btBillingMAWB: this.$checkPermission(['button_AERouteCentral_BillingMAWB']),
        btBillingHAWB: this.$checkPermission(['button_AERouteCentral_BillingHAWB']),
        btPrintMAWB: this.$checkPermission(['button_AERouteCentral_PrintMAWB']),
        btPrintHAWB: this.$checkPermission(['button_AERouteCentral_PrintHAWB'])
      },
      billVisible: false,
      track: {
        btTakeOff: this.$checkPermission(['button_AERouteCentral_TakeOff']),
        btArrival: this.$checkPermission(['button_AERouteCentral_Arrival']),
        btFlightState: this.$checkPermission(['button_AERouteCentral_LockFlight']) || this.$checkPermission(['button_AERouteCentral_UnlockFlight'])
      },
      trackVisible: false
    }
    // 现场操作
    moreOperatorVisible.operatorVisible = moreOperatorVisible.operator.btDeclareCustoms || moreOperatorVisible.operator.btSiteRemark ||
      moreOperatorVisible.operator.btOtherCharges || moreOperatorVisible.operator.btDelivery || moreOperatorVisible.operator.btDeliveryAgent ||
      moreOperatorVisible.operator.btUploadLoadingPic || moreOperatorVisible.operator.btLabel
    // 制单
    moreOperatorVisible.billVisible = moreOperatorVisible.bill.btBillingMAWB || moreOperatorVisible.bill.btBillingHAW ||
      moreOperatorVisible.bill.btPrintMAWB || moreOperatorVisible.bill.btPrintHAWB
    // 跟踪
    moreOperatorVisible.trackVisible = moreOperatorVisible.track.btTakeOff || moreOperatorVisible.track.btArrival ||
      moreOperatorVisible.track.btFlightState
    return {
      isZh: this.$store.getters.language === 'zh',
      loading: false,
      isAdvancedQuery: false, // 是否为高级查询
      timeRange: TODAY.code,
      commonFilter: {
        start: '', // flight.ETD
        end: '', // flight.ETD
        regions: [] // port.REGION
      },
      oldMblNo: '',
      mblNo: '',
      autoRefresh,
      showAll: false, // true：显示所有，false：过滤掉无业务航班
      originRowData: [], // 原始行数据
      selectedNode: null,
      selectedRows: [],
      keyboardSelectStatistics: {
        visible: false,
        quantityContract: 0,
        weightContract: 0,
        cubageContract: 0,
        quantityActual: 0,
        weightActual: 0,
        cubageActual: 0
      },
      openedJobKeys: [], // 已打开新页签的job的key
      quantityActual: 0,
      weightActual: 0,
      cubageActual: 0,
      quantityContract: 0,
      weightContract: 0,
      cubageContract: 0,
      moreOperatorVisible,
      // 导出模板按钮状态
      exportTemplateEnabled: false,
      /* 更多操作按钮状态 */
      btLoadingEnabled: false,
      btFlightStateLabel: this.$t('queryJob.lockFlight'),
      btFlightStateEnabled: false,
      btDeliveryAgentEnabled: false,
      btBookingDoneEnabled: false,
      btPullInEnabled: false,
      btAdjustFlightEnabled: false,
      btMixFlightEnabled: false,
      btCheckBookingEnabled: false,
      btCancelCheckBookingEnabled: false,
      btTakeOffEnabled: false,
      btArrivalEnabled: false,
      btDeliveryEnabled: false,
      btDeclareCustomsEnabled: false,
      btCopyWarehouseInfoEnabled: false,
      btBookingInEnabled: false,
      btOperatorRemarksEnabled: false,
      btOtherWarehouseNotesEnabled: false,
      btOtherChargesEnabled: false,
      btSiteRemarkEnabled: false,
      btBillingMAWBEnabled: false,
      btBillingHAWBEnabled: false,
      btPrintMAWBEnabled: false,
      btPrintHAWBEnabled: false,
      btUploadLoadingPicEnabled: false,
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      bookingDialog: {
        visible: false,
        flight: {},
        jobs: []
      },
      queryMblDialog: {
        visible: false
      },
      mixFlightDialog: {
        visible: false,
        jobs: []
      },
      loadingNoteDialog: {
        visible: false,
        jobs: []
      },
      warehouseEntryDialog: {
        visible: false,
        job: {}
      },
      bookingDoneDialog: {
        visible: false,
        flight: {}
      },
      declareCustomsDialog: {
        visible: false,
        job: {}
      },
      operatorRemarkDialog: {
        visible: false,
        operatorId: '',
        job: {}
      },
      updateFlightDialog: {
        visible: false,
        operation: 0,
        flight: {}
      },
      deliverAgentDialog: {
        visible: false,
        jobs: []
      },
      uploadLoadingPicDialog: {
        visible: false,
        job: {}
      },
      warehouseLabelDialog: {
        visible: false,
        job: {},
        warehouseIn: {}
      },
      billingDialog: {
        visible: false,
        job: {},
        docType: ''
      }
    }
  },
  computed: {
    rowData() {
      if (this.showAll) {
        return this.originRowData
      }
      const validKeySet = new Set()
      for (const item of this.originRowData) {
        if (item.dataType === 4 || item.dataType === 5) {
          const keys = item.path.split(',')
          validKeySet.add(keys[0])
          validKeySet.add(keys[0] + ',' + keys[1])
          validKeySet.add(keys[0] + ',' + keys[1] + ',' + keys[2])
        }
      }
      const data = this.originRowData.filter(p => {
        if (p.dataType === 1 || p.dataType === 2 || p.dataType === 3) {
          return validKeySet.has(p.path)
        } else {
          return true
        }
      })
      console.info('rowData', data)
      return data || []
    },
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    },
    validFlight() {
      return this.selectedRow && this.selectedRow.dataType === 2 && this.selectedRow.uuid && this.selectedRow.children.length > 0
    },
    bookingEnable() {
      if (!this.selectedRow || this.selectedRow.dataType !== 2 || !this.selectedRow.uuid) {
        return false
      }
      const etd = this.selectedRow.path.split(',')[0]
      const now = moment().format('YYYY-MM-DD')
      return etd >= now
    },
    curDataType() { // 1: ETD 2: 航班 3: 集装器 4: 主票/直单/一主一分 5: 小票
      return this.selectedRow ? this.selectedRow.dataType : 0
    }
  },
  watch: {
    selectedRow(newVal, oldVal) {
      this.delayUpdateButtonState()
    },
    selectedRows(newVal, oldVal) {
      this.delayUpdateButtonState()
    }
  },
  created() {
    // 扩展data
    Object.assign(this, {
      TYPE_NAMES,
      TIME_RANGES,
      CUSTOM,
      advanceQueryConditions: [], // 高级查询条件
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        suppressMoveWhenRowDragging: true, // 如果为true，则在拖动行时不会移动行。这意味着您可以拖动行，而不会影响行的顺序。
        treeData: true,
        groupDefaultExpanded: 0,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_Flight'),
          width: 400,
          rowDrag: params => params.data && !params.data.lclMasterUuid &&
            !([1, 2, 3, 6].indexOf(params.data.dataType) > -1) &&
            params.data.lob === 'AE' &&
          params.data.path.indexOf('Pending Order') === -1, // 小票不可拖动
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              if (!params.data) {
                return false
              }
              const dataType = params.data.dataType
              return dataType === 2 || dataType === 4 || dataType === 5
            },
            innerRenderer: params => {
              const data = params.data
              if (!data) {
                return ''
              }
              if (data.dataType === 1) {
                return params.value
              } else if (data.dataType === 2) {
                if (data.flightNo) {
                  const etd = data.path.split(',')[0]
                  let text = data.flightNo
                  text += ' ('
                  text += moment(etd).format('MM/DD')
                  if (data.departureTime) {
                    text += ' ' + data.departureTime
                  }
                  text += ')'
                  if (data.settleState === 1) {
                    text += this.$t('Message.Locked')
                  } else if (data.settleState === 2) {
                    text += this.$t('CargoMsg.Cargo_Approved')
                  }
                  if (data.atd) {
                    text += '  ' + this.$t('queryJob.takeOff2') + ' ('
                    text += moment(data.atd).format('MM/DD HH:mm')
                    text += ')'
                  }
                  if (data.ata) {
                    text += '  ' + this.$t('queryJob.arrivedAtPort') + '('
                    text += moment(data.ata).format('MM/DD HH:mm')
                    text += ')'
                  }
                  let aircraft = ''
                  if (data.charterFlightOrCharterVessel && data.charterFlightOrCharterVessel > 0) {
                    const isCharter = data.charterFlightOrCharterVessel === 1
                    if (isCharter) {
                      aircraft = this.$t('Pricing.Aircraft') + '：' + data.aircraft
                    }
                    const pcs = this.$t('CargoMsg.Cargo_Pcs')
                    const numStyle = data.flightContainerNum < data.jobContainerNum ? 'color:red' : ''
                    aircraft += '&nbsp;&nbsp;&nbsp;&nbsp;' + this.$t('CargoMsg.Cargo_NumberOfCartridges') + '：[' + data.flightContainerNum + pcs + '/'
                    if (numStyle) {
                      aircraft += '<span style="' + numStyle + '">' + data.jobContainerNum + '</span>'
                    } else {
                      aircraft += data.jobContainerNum
                    }
                    aircraft += pcs + ']&nbsp;&nbsp;&nbsp;&nbsp;'
                    if (isCharter) {
                      const cubagePercent = data.flightJobCubage && data.flightCubageLimit ? (data.flightJobCubage / data.flightCubageLimit * 100).toFixed(2) : 0
                      const weightPercent = data.flightJobWeight && data.flightWeightLimit ? (data.flightJobWeight / data.flightWeightLimit * 100).toFixed(2) : 0

                      const cubageMsg = cubagePercent > 100 ? '<span style="color:red">' + cubagePercent + '</span>' : cubagePercent
                      const weightMsg = weightPercent > 100 ? '<span style="color:red">' + weightPercent + '</span>' : weightPercent
                      aircraft += this.$t('SeaExport.TotalCubage') + '： [' + data.flightCubageLimit + 'm³/' + data.flightJobCubage + 'm³] ' + cubageMsg + '%&nbsp;&nbsp;&nbsp;&nbsp;'
                      aircraft += this.$t('SeaExport.TotalWeight2') + '： [' + data.flightWeightLimit + 'KGS/' + data.flightJobWeight + 'KGS]' + weightMsg + '%'
                    }
                  }
                  return text + aircraft
                } else {
                  return data.departureTime
                }
              } else if (data.dataType === 3) {
                if (!data.containerNumber && !data.containerCode) {
                  return '<span style="color:red">' + this.$t('CargoMsg.cargo_unloaded_container_business') + '</span>'
                }
                const containerNumber = (data.containerNumber || '') + (data.containerNumber ? '-' : '') + data.containerCode
                const containerType = CommonState.getNameByCode(SystemConstants.AIRPLANE_CONTAINER_TYPES, data.containerType)
                const cubageName = this.$t('CargoMsg.Cargo_Cubage')
                const capacityPercent = data.jobUldCapacity && data.uldCapacity ? (data.jobUldCapacity / data.uldCapacity * 100).toFixed(2) : 0
                const weightPercent = data.jobUldWeight && data.uldWeight ? (data.jobUldWeight / data.uldWeight * 100).toFixed(2) : 0

                const capacityMsg = capacityPercent > 100 ? '<span style="color:red">' + capacityPercent + '</span>' : capacityPercent
                const weightMsg = weightPercent > 100 ? '<span style="color:red">' + weightPercent + '</span>' : weightPercent
                const msg = containerNumber + '&nbsp;&nbsp;(' + containerType + ')&nbsp;&nbsp;&nbsp;&nbsp;' + cubageName + '[' + data.uldCapacity + 'm³/' + data.jobUldCapacity + 'm³]' + '&nbsp;&nbsp;' + capacityMsg + '%&nbsp;&nbsp;&nbsp;&nbsp;' + this.$t('CargoMsg.Cargo_Weight') + '[' + data.uldWeight + 'KGS/' + data.jobUldWeight + 'KGS]' + '&nbsp;&nbsp;' + weightMsg + '%'
                if (data.matchType === 2 && data.charterFlightOrCharterVessel === 2) { // 业务航班集装器匹配不上的，显示红色
                  return '<span style="color:red">' + msg + '</span>'
                }
                return msg
              } else if (data.dataType === 4 || data.dataType === 5) {
                const toLookMethod = this.documentManage.getPath('toLook')
                const showBusinessInfoMethod = this.documentManage.getPath('showBusinessInfo')
                return `<a href="javascript:void(0)"  style="border-bottom: 1px solid;" onclick="${toLookMethod}(event)">${data.jobNo}</a>
                  <img src="${jobDetailIcon}" height="16" width="16" style="vertical-align: sub;margin-left:3px;cursor:pointer" onclick="${showBusinessInfoMethod}(event)"/>`
              } else if (data.dataType === 6) {
                return data.receiptNo
              } else {
                return ''
              }
            }
          }
        },
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
          // 重置（多选）选中行
          this.selectedRows = []
          if (this.rowData.length > 0) {
            setTimeout(() => {
              let expandedNode // 需展开的node
              if (this.oldMblNo) { // 查找与提单号匹配的项，并展开
                const nodes = this.gridApi.rowModel.rootNode.allLeafChildren
                const expandedNode = nodes.find(p => p.data.dataType === 5 && p.data.mbl === this.oldMblNo)
                if (expandedNode) {
                  expandedNode.parent.expanded = true
                  expandedNode.parent.parent.expanded = true
                  if (expandedNode.data.lclMasterUuid) {
                    expandedNode.parent.parent.parent.expanded = true
                  }
                }
              }
              if (!expandedNode) { // 默认展开第一项
                expandedNode = this.gridApi.rowModel.rowsToDisplay[0]
                while (expandedNode) {
                  expandedNode.expanded = true
                  expandedNode = expandedNode.childrenAfterFilter[0]
                }
              }
              this.gridApi.onGroupExpandedOrCollapsed()
              this.onRowSpanMethod(event)
            }, 100)
          } else {
            this.onRowSpanMethod(event)
          }
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        // 多选（勾选框触发）
        onRowSelected: event => {
          if (!event.data) {
            return
          }
          if (event.data.dataType === 2 || event.data.dataType === 4 || event.data.dataType === 5) { // 有效选中
            this.selectedRows = this.gridApi.getSelectedRows().filter(p => p.dataType === 2 || p.dataType === 4 || p.dataType === 5)
          } else {
            event.node.setSelected(false) // 取消无效选中
          }
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
          this.onRowSpanMethod(event)
        },
        onRowDragEnd: this.onRowDragEnd, // 拖动结束
        getRowStyle: function(params) {
          if (params.data.rowSpan > 1) { // 跨行显示，设置z-index
            return { 'z-index': 1 }
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: this.getColumnDefs(),
      gridApi: null,
      updateBtnStateSeq: 1, // 执行更新按钮状态操作的次序
      documentManage: new DocumentManage(),
      timerId: 0 // 定时器ID
    })
    this.onTimeRangeChange()

    if (this.$route.query.flightNo) {
      const flightNo = this.$route.query.flightNo
      this.isAdvancedQuery = true
      const data = [new AdvancedSearchOption('flightNo', 'flightDesc.FLIGHT_NO', flightNo, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json()]
      this.toAdvancedQuery(data)
    } else {
      this.toAdvancedQuery()
    }
  },
  activated() {
    if (this.openedJobKeys.length > 0) {
      const map = new Map()
      for (const row of this.rowData) {
        if (this.openedJobKeys.includes(row.uuid)) {
          map.set(row.uuid, row)
        }
      }
      if (map.size > 0) {
        getAirExportJobListByKeys({ keys: [...map.keys()].join(',') }).then(res => {
          for (const item of res.data) {
            const oldItem = map.get(item.uuid)
            if (!oldItem) {
              continue
            }
            for (const key in oldItem) {
              if (typeof oldItem[key] === 'object' || typeof item[key] === 'undefined') {
                continue
              }
              oldItem[key] = item[key]
            }
          }
          this.refreshRows([...map.values()])
        })
      }
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('toLook', function(e) {
      self.toLook(e)
    })
    this.documentManage.set('showBusinessInfo', function(e) {
      self.showBusinessInfo(e)
    })
    this.documentManage.set('loadingBoard', function(e) {
      self.loadingBoard(e)
    })
  },
  mounted() {
    this.$refs.searchItem.keyWords = 'keyWords' // 该输入框用不到，但必须有值，否则简单查询无法验证通过
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: aeRouteCentralJS.methods
}
</script>

<style scoped lang="scss">
#app .app-main-content .grid-view .main-content ::v-deep {
  .cargo-advance-search-quick {
    .el-input {
      display: none;
    }
  }
  .el-submenu__title {
    border-bottom-width: 0;
  }
  .grid-wrapper {
    .ag-header-group-cell-no-group::after {
      border-right: none;
    }
    .ag-header-group-cell-label {
      justify-content: center;
    }
    .ag-theme-balham {
      .ag-group-value {
        a {
          color: blue;
        }
      }
    }
    .row-span-class {
      background-color: #F7F7F7 !important;
      border-top: 1px solid #DBDFE6 !important;
      border-bottom: 1px solid #DBDFE6 !important;
      display: flex;
      text-align: center;
      align-items: center;
      word-wrap: break-word;
      > span {
        width: 100%;
        white-space: wrap;
      }
    }
    .row-single-class {
      text-align: center;
    }
    .row-hide-class {
      background-color: #F7F7F7 !important;
      border-top: 1px solid #F7F7F7 !important;
      border-bottom: 1px solid #F7F7F7 !important;
    }
  }
}
</style>
